import axios from "axios";

import { MatxLayoutSettings } from "app/components/MatxLayout/settings";

const axiosInstance = axios.create({
  baseURL: MatxLayoutSettings.siteSettings.baseURL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      // TODO: Common error mapping to an object can happen here
      // Especially if we want to flatten validation errors / reduce code in components
      //(error.response && error.response.data) || "Something went wrong!"
      error
    )
);

export default axiosInstance;
